import React, { useState, useEffect } from "react";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isWithinInterval, parse } from "date-fns";
import { toast, ToastContainer } from "react-toastify";
// import booksUsageData from "./booksUsageData.json";
import BooksUsageTable from "./booksUsageTbl";
import { getBooksUsageListSvc } from './bookUsageSvc.js'

const BookUsageCtrl = () => {

    const params = new URLSearchParams(window.location.search);
    const [bookId, setBookId] = useState(0)
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstUsage, setLstUsage] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [bookUsageData, setBookUsageData] = useState([]);

    useEffect(() => {
        // console.log("Book ID from URL:", params.get("bookId"));
        setBookId(params.get("bookId") || 0);

    }, [params]);
    useEffect(() => {
        const today = new Date();
        const past = new Date();
        past.setMonth(today.getMonth() - 1);
        setFromDate(past);
        setToDate(today);
        getBooksUsage(past, today);
    }, [])
    function getBooksUsage(fDt, tDt) {
        getBooksUsageListSvc(fDt, tDt, handleUsageResponse);
    }
    function handleUsageResponse(data) {
        // console.log("handleUsageResponse called, data", data);
        if (data.status === "Success") {
            // setLstSub(data.lstSubject);
            setBookUsageData(data.lstUsage);
            setLstUsage(data.lstUsage);
            // getPeriodList(pSectionId);

        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }
    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-lg-6 col-md-6 col-sm-8 col-xs-12 col-centered padding-remove"
                style={{
                    marginTop: "20px",
                    opacity: opacity,
                    pointerEvents: opacity === 1 ? "auto" : "none",
                    cursor: opacity === 1 ? "pointer" : "default"
                }}
            >
                <div className="col-sm-12 col-centered padding-remove">
                    <div style={{ marginBottom: "20px", display: "flex", gap: "15px", alignItems: "flex-end" }}>
                        <label>
                            From:{" "}
                            <DatePicker
                                className='form-control'
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="DD-MM-YYYY"
                            />
                        </label>
                        <label>
                            To:{" "}
                            <DatePicker
                                className='form-control'
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd-MM-yyyy"
                                placeholderText="DD-MM-YYYY"
                            />
                        </label>
                        <button onClick={getBooksUsage}
                            style={{
                                padding: "6px 12px",
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                margin: 6,
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }} >
                            Get Usage Report
                        </button>
                    </div>

                    <BooksUsageTable
                        lstUsage={lstUsage}
                    />
                </div>
            </div>
        </div>
    );
};

export default BookUsageCtrl;